import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import { useReactToPrint } from 'react-to-print';
import moment from "moment";

// Reactstrap components
import { Button, Col, Container, Modal, ModalBody, ModalFooter, Row } from "reactstrap";
import Form from "reactstrap/lib/Form";
import ModalHeader from "reactstrap/lib/ModalHeader";
import ProgressBar from "components/ProgressBar/StepperProgress";

// style
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

// helpers
import { formateDateandTime, formateDate, transformValueFloattoFormated } from "helpers/formats";

// services
import { api_GET } from "../../../services/api_service.js";
import { showMessage } from "../../../services/message.js";

// views
import AcoesGestor from "../../../views/Shared/AcoesGestor";
import { api_POST } from "../../../services/api_service";

//Context
import { useAuth } from "../../../context/auth";

export default function FichaRequerimento({ item, handleReturn, showAcoesGestor }) {
    const { session, setLoading, setupSistema } = useAuth();

    const [requerimento, set_requerimento] = React.useState(null);

    const [stepAtual, set_stepAtual] = React.useState(0);
    const [steps, set_steps] = React.useState([]);

    // pegar as justificativas feitas no protocolo na tela de manutenção
    const [justificativaList, setJustificativaList] = React.useState([]);

    const [isLoadingEmitirGuia, setIsLoadingEmitirGuia] = React.useState(false);

    const [modal, setModal] = React.useState(false);

    const toggleModal = () => setModal(!modal);


    const laodJustificativasProtocolo = () => {
        api_GET(`protocolo/GetJustificativaManuntecaoProtocolo/${item.protocolo_Id}`)
            .then(result => setJustificativaList(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const [existAcaoDocumento, setExistAcaoDocumento] = useState(null);
    const loadItem = () => {
        //verifica se a ação teve o step de documento
        api_GET('setupSolicitacao/GetByAcaoId/' + item.setupSolicitacaoAcao_Id)
            .then(result => setExistAcaoDocumento(result.data.solicitacaoAcoes.filter(f => f.setupSolicitacaoAcao_Id == item.setupSolicitacaoAcao_Id)[0].acaoDocumentos.length))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));

        if (item.etapaCadastro == 0 && existAcaoDocumento > 0) {
            showMessage("Aviso", "No momento não é possivel visualizar os dados em andamento, porque o Requerimento ainda não passou da tela de identificação.", "warning", null)
            handleReturn();
        }

        if (document.querySelector('.main-panel') != null)
            document.querySelector('.main-panel').scrollTop = 0;

        set_requerimento(item);
        setTimeout(() => {
            if (item.fluxoCadastroEtapaAtual != null)
                set_stepAtual(item.fluxoCadastroEtapaAtual.ordem - 1);
        }, 1000);
    }

    const openGuiaCobranca = (rowData) => {
        const arquivoPDF = rowData.logCobrancas.filter(l => l.nomeArquivo != null);
        const linkSource = `data:application/pdf;base64,${arquivoPDF[0].nomeArquivo}`;
        const downloadLink = document.createElement("a");
        const fileName = requerimento.numeroRequerimento + ".pdf";

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    const loadSteps = () => {
        api_GET('FluxoCadastro/BySetupSolicitacaoAcaoId/' + item.setupSolicitacaoAcao_Id)
            .then(result => {
                if (result.data != null) {
                    let etapas = [];
                    result.data.fluxoCadastroEtapas.sort(function (a, b) { return a.ordem - b.ordem }).map(m => {
                        etapas.push(m.tipo);
                    })
                    set_steps(etapas);
                }
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const [historicoAnaliseGestor, set_historicoAnaliseGestor] = React.useState([]);
    const loadHistoricoAnaliseGestor = () => {
        api_GET('requerimento/GetHistoricoAprovacaoRequerimento/' + item.requerimento_Id)
            .then(result => set_historicoAnaliseGestor(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }


    useEffect(() => {
        loadItem();
        loadSteps();
        loadHistoricoAnaliseGestor();
        laodJustificativasProtocolo();
    }, []);

    const componentRef = React.useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        copyStyles: true
    });

    const handleEmitirGuia = () => {
        let json_submit = {
            requerimento_Id: requerimento.requerimento_Id
        }

        setIsLoadingEmitirGuia(true);
        api_POST('AnaliseRequerimento/PostRequerimentoCobranca', json_submit)
            .then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', window.location.reload()))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    return (
        <>
            <Modal isOpen={modal} toggle={toggleModal} size={"lg"}>
                <ModalHeader toggle={toggleModal}>Histórico de Justificativas na tela de manunteção.</ModalHeader>
                <ModalBody>
                    <Form>
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col" className="">Data da Justificativa</th>
                                        <th scope="col">Observação</th>
                                        <th scope="col">Usuário</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {justificativaList.length > 0 && justificativaList.map(justificativa => (
                                        <tr>
                                            <td>{formateDateandTime(justificativa.dataJustificativa)}</td>
                                            <td>{justificativa.observacao}</td>
                                            <td>{justificativa.nome ?? ""}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleModal}>OK</Button>
                </ModalFooter>
            </Modal>
            {isLoadingEmitirGuia &&
                <div className="carregandoCmp">
                    <div className="box">
                        <img src={require("assets/img/loading.gif")}></img>
                    </div>
                </div>
            }
            {!isLoadingEmitirGuia && requerimento != null &&
                <div>
                    <Container className="text-center">
                        <ProgressBar stepValue={stepAtual} steps={steps} />
                    </Container>
                    <div className="row">
                        <div className="col-6 col-lg-6">
                            {handleReturn != null &&
                                <Button color="secondary" onClick={handleReturn}><i class="fas fa-chevron-left"></i> VOLTAR</Button>
                            }
                        </div>
                        <div className="col-6 col-lg-6 text-right">
                            <Button color="danger" onClick={handlePrint}><i class="fas fa-print"></i> IMPRIMIR</Button>
                        </div>
                    </div>
                    <div className="card card-stats" ref={componentRef}>
                        <div className="card-body">
                            <div className="row text-center">
                                <div className="col-12 col-lg-12">
                                    <h2 className="titulo-solicitacao">{requerimento.setupSolicitacaoAcao.setupSolicitacao.categoria.descricao}</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-lg-12">
                                    <h3 id="nome_empresa" className="titulo-consulta">Empresa</h3>
                                    <div className="line-protocolo"></div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6 col-lg-6 col-sm-12">
                                    <h6 style={{ paddingTop: "5px" }}>{requerimento.requerimentoTransportador.length > 0 ? requerimento.requerimentoTransportador[0].nome_Fantasia : requerimento.protocolo.protocoloTransportador[0].nome_Fantasia}</h6>
                                </div>
                                <div className="col-6  col-lg-6 col-sm-12 text-mobile">
                                    <h6 style={{ paddingTop: "5px" }}>{requerimento.cpf_Cnpj}</h6>
                                </div>
                                <div className="col-6  col-lg-6 col-sm-12">
                                    <p><b>Razão Social:</b> {requerimento.requerimentoTransportador.length > 0 ? requerimento.requerimentoTransportador[0].razaoSocial : requerimento.protocolo.protocoloTransportador[0].razaoSocial}</p>
                                </div>
                                <div className="col-2  col-lg-2 col-sm-12">
                                    <p><b>CCM:</b> {requerimento.requerimentoTransportador.length > 0 ? requerimento.requerimentoTransportador[0].ccm : requerimento.protocolo.protocoloTransportador[0].ccm}</p>
                                </div>
                                <div className="col-6  col-lg-4 col-sm-12">
                                    <p><b>Código Cadastro:</b> {requerimento?.protocolo?.codigoCadastro}</p>
                                </div>
                                {requerimento.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla != "RGG" &&
                                    <div className="col-4  col-lg-4 col-sm-12">
                                        <p><b>Ramo:</b> {requerimento.requerimentoTransportador.length > 0 ? requerimento.requerimentoTransportador[0].ramoAtividade : requerimento.protocolo.protocoloTransportador[0].ramoAtividade}</p>
                                    </div>}
                                <div className="col-4 col-lg-4 col-sm-12">
                                    <p><b>Tipo de Indústria / Coméricio:</b> {requerimento.requerimentoTransportador.length > 0 ? requerimento.requerimentoTransportador[0].tipoIndustriaComercio : requerimento.protocolo.protocoloTransportador[0].tipoIndustriaComercio}</p>
                                </div>
                                <div className="col-2 col-lg-2 col-sm-12">
                                    <p><b>CEP:</b> {requerimento.requerimentoTransportador.length > 0 ? requerimento.requerimentoTransportador[0].cep : requerimento.protocolo.protocoloTransportador[0].cep}</p>
                                </div>
                                <div className="col-6 col-lg-6 col-sm-12">
                                    <p><b>Endereço:</b> {requerimento.requerimentoTransportador.length > 0 ? requerimento.requerimentoTransportador[0].logradouro + ", " + requerimento.requerimentoTransportador[0].numEndereco + ", " + requerimento.requerimentoTransportador[0].complemento : requerimento.protocolo.protocoloTransportador[0].logradouro + ", " + requerimento.protocolo.protocoloTransportador[0].numEndereco}</p>
                                </div>
                                <div className="col-6 col-lg-6 col-sm-12">
                                    <p><b>Bairro:</b> {requerimento.requerimentoTransportador.length > 0 ? requerimento.requerimentoTransportador[0].bairro : requerimento.protocolo.protocoloTransportador[0].bairro}</p>
                                </div>
                                <div className="col-6 col-lg-6 col-sm-12">
                                    <p><b>Cidade:</b> {requerimento.requerimentoTransportador.length > 0 ? requerimento.requerimentoTransportador[0].cidade : requerimento.protocolo.protocoloTransportador[0].cidade}</p>
                                </div>
                                <div className="col-12 col-lg-12 col-sm-12">
                                    {session != null && session.tipoAcesso == "AreaRestrita" && justificativaList.length > 0 &&
                                        <div className="d-flex align-items-center justify-content-center">
                                            <Button color="link" className="text-end" onClick={() => setModal(true)}>
                                                <i className="fas fa-file-alt mr-2"></i>
                                                Observações do Cadastro
                                            </Button>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-lg-12">
                                    <h3 className="titulo-consulta">Responsável</h3>
                                    <div className="line-protocolo"></div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6 col-lg-6 col-sm-12">
                                    <h6 style={{ paddingTop: "5px" }}>{requerimento.requerimentoTransportador.length > 0 ? requerimento.requerimentoTransportador[0].nomeResponsavel : requerimento.protocolo.protocoloTransportador[0].nomeResponsavel}</h6>
                                </div>
                                <div className="col-6 col-lg-6 col-sm-12 text-mobile">
                                    <h6 style={{ paddingTop: "5px" }}>{requerimento.email}</h6>
                                </div>
                                <div className="col-6 col-lg-6 col-sm-12">
                                    <p><b>Telefone:</b> {requerimento.requerimentoTransportador.length > 0 ? requerimento.requerimentoTransportador[0].telefone : requerimento.protocolo.protocoloTransportador[0].telefone}</p>
                                </div>
                                <div className="col-6 col-lg-6 col-sm-12 text-mobile">
                                    <p><b>Celular:</b> {requerimento.requerimentoTransportador.length > 0 ? requerimento.requerimentoTransportador[0].celular : requerimento.protocolo.protocoloTransportador[0].celular}</p>
                                </div>
                                {requerimento.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla == "RGG" &&
                                  <div className="col-12 col-lg-12 col-sm-12">
                                      <p><b>Responsável Técnico (CREA):</b> {requerimento.requerimentoTransportador.length > 0 ? requerimento.requerimentoTransportador[0]?.nomeResponsavelTecnico : requerimento.protocolo.protocoloTransportador[0]?.nomeResponsavelTecnico}</p>
                                  </div>}
                            </div>
                            <div className="row">
                                <div className="col-12 col-lg-12">
                                    <h3 className="titulo-consulta">Requerimento</h3>
                                    <div className="line-protocolo"></div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 col-lg-4">
                                    <b>Tipo:</b> <p>{requerimento.setupSolicitacaoAcao.acao}</p>
                                </div>
                                <div className="col-4 col-lg-4">
                                    <b>Número :</b> <p>{requerimento.numeroRequerimento}</p>
                                </div>
                                <div className="col-4 col-lg-4">
                                    <b>Status: </b> <p>{requerimento.status}</p>
                                </div>
                            </div>
                            {requerimento.status == "Divergente" && requerimento.requerimentoAnaliseGestor != null &&
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <b>Divergência: </b> <p>{requerimento.requerimentoAnaliseGestor.sort(function (a, b) { return new Date(b.dataAnalise) - new Date(a.dataAnalise); })[0].observacao}</p>
                                    </div>
                                </div>
                            }
                            {requerimento.requerimentoMotivoCancelamento.length > 0 &&
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <h3 className="titulo-consulta">Motivo do Cancelamento</h3>
                                        <div className="line-protocolo"></div>
                                    </div>
                                    <div className="col-12 col-lg-12">
                                        <p>{requerimento.requerimentoMotivoCancelamento[0].motivo}</p>
                                    </div>
                                </div>
                            }
                            {requerimento.requerimentoTransportadorVeiculo != null && requerimento.requerimentoTransportadorVeiculo.length > 0 &&
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <h3 className="titulo-consulta">Veículos</h3>
                                        <div className="line-protocolo"></div>
                                    </div>
                                    <div className="col-12 col-lg-12">
                                        {requerimento.requerimentoTransportadorVeiculo.map((item, key) => (
                                            <div key={key}>
                                                <div className="row">
                                                    <div className="col-2 col-lg-2">
                                                        <b>Placa:</b> <p>{item.placa}</p>
                                                    </div>
                                                    <div className="col-2 col-lg-2">
                                                        <b>Tipo:</b> <p>{item.tipo}</p>
                                                    </div>
                                                    {requerimento.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla == "RGG" &&
                                                        <div className="col-2 col-lg-4">
                                                            <b>Modalidades:</b> {item.requerimentoTransportadorVeiculoModalidade && item.requerimentoTransportadorVeiculoModalidade.map((item, key) => (
                                                                <p key={key}>{item.modalidade}</p>))}
                                                        </div>}
                                                    <div className="col-4 col-lg-4">
                                                        <b>Marca/Modelo:</b> <p>{item.marca}</p>
                                                    </div>
                                                    <div className="col-2 col-lg-2">
                                                        <b>Ano Fabricação:</b> <p>{item.anoFabricacao}</p>
                                                    </div>
                                                    <div className="col-2 col-lg-2">
                                                        <b>Ano Fab. Equip.:</b> <p>{item.anoFabricacaoEquipamento}</p>
                                                    </div>
                                                    <div className="col-2 col-lg-2">
                                                        <b>Cor:</b> <p>{item.cor}</p>
                                                    </div>
                                                    <div className="col-2 col-lg-2">
                                                        <b>Tara (kg):</b> <p>{item.tara}</p>
                                                    </div>
                                                    <div className="col-4 col-lg-4">
                                                        <b>Capacidade (kg):</b> <p>{item.capacidadeCarga}</p>
                                                    </div>
                                                    <div className="col-2 col-lg-2">
                                                        <b>Volume (m³):</b> <p>{transformValueFloattoFormated(item.volume)}</p>
                                                    </div>
                                                    <div className="col-4 col-lg-4">
                                                        <b>Renavam:</b> <p>{item.numeroRenavam}</p>
                                                    </div>
                                                    <div className="col-4 col-lg-4">
                                                        <b>Proprietário ou Locado:</b> <p>{item.proprietarioOuLocado}</p>
                                                    </div>
                                                    <div className="col-2 col-lg-2">
                                                        <b>Status:</b> <p>{item.status}</p>
                                                    </div>
                                                    {!!item?.statusAnaliseComprovanteTara &&
                                                        <div className="col-4 col-lg-4">
                                                            <b>Status Análise Comprovante Tara:</b> <p>{item.statusAnaliseComprovanteTara}</p>
                                                        </div>
                                                    }
                                                    {!!item?.motivoReprovaAnaliseComprovanteTara &&
                                                        <div className="col-6 col-lg-6">
                                                            <b>Motivo Reprova Análise Comprovante Tara:</b> <p>{item.motivoReprovaAnaliseComprovanteTara}</p>
                                                        </div>
                                                    }
                                                    {!!item?.statusAnaliseInspecaoInmetro &&
                                                        <div className="col-4 col-lg-4">
                                                            <b>Status Análise Inspeção Inmetro:</b> <p>{item.statusAnaliseInspecaoInmetro}</p>
                                                        </div>
                                                    }
                                                    {!!item?.motivoReprovaInspecaoInmetro &&
                                                        <div className="col-6 col-lg-6">
                                                            <b>Motivo Reprova Inspeção Inmetro:</b> <p>{item.motivoReprovaInspecaoInmetro}</p>
                                                        </div>
                                                    }
                                                    {!!item?.statusAnaliseRenavam &&
                                                        <div className="col-4 col-lg-4">
                                                            <b>Status Análise Renavam:</b> <p>{item.statusAnaliseRenavam}</p>
                                                        </div>
                                                    }
                                                    {!!item?.motivoReprovaRenavam &&
                                                        <div className="col-6 col-lg-6">
                                                            <b>Motivo Reprova Análise Renavam:</b> <p>{item.motivoReprovaRenavam}</p>
                                                        </div>
                                                    }
                                                </div>
                                                {item.requerimentoTransportadorAgendamento.length > 0 &&
                                                    <div className="row">
                                                        <div className="col-4 col-lg-4">
                                                            <b>Agendamento da Vistoria:</b> <p>{formateDate(item.requerimentoTransportadorAgendamento[0].dataHora)}</p>
                                                        </div>
                                                        <div className="col-4 col-lg-4">
                                                            <b>Situação do Agendamento:</b> <p>{item.requerimentoTransportadorAgendamento[0].situacao}</p>
                                                        </div>
                                                        {item.requerimentoTransportadorAgendamento[0].requerimentoTransportadorVistoria.length > 0 &&
                                                            <>
                                                                <div className="col-4 col-lg-4">
                                                                    <b>Data da Vistoria:</b> <p>{formateDate(item.requerimentoTransportadorAgendamento[0].requerimentoTransportadorVistoria[0].dataHoraAtualizacao)}</p>
                                                                </div>
                                                                <div className="col-4 col-lg-4">
                                                                    <b>Situação da Vistoria:</b> <p>{item.requerimentoTransportadorAgendamento[0].requerimentoTransportadorVistoria[0].situacao}</p>
                                                                </div>
                                                                <div className="col-8 col-lg-8">
                                                                    <b>Observações:</b> <p>{item.requerimentoTransportadorAgendamento[0].requerimentoTransportadorVistoria[0].observacao}</p>
                                                                </div>
                                                                <div className="col-12 col-lg-12">
                                                                    <a href={setupSistema?.caminhoVirtual + item.requerimentoTransportadorAgendamento[0].requerimentoTransportadorVistoria[0].arquivoLaudoVistoria} target="_blank">Laudo da Vistoria</a>
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                }
                                                <div className="row">
                                                    {item.arquivoRenavam != null && <div className="col-3 col-lg-3"><a href={setupSistema?.caminhoVirtual + item.arquivoRenavam} target="_blank">Arquivo Renavam</a></div>}
                                                    {item.arquivoInspecaoInmetro != null && <div className="col-3 col-lg-3"><a href={setupSistema?.caminhoVirtual + item.arquivoInspecaoInmetro} target="_blank">Arquivo Inspeção Inmetro</a></div>}
                                                    {item.arquivoComprovanteTara != null && <div className="col-3 col-lg-3"><a href={setupSistema?.caminhoVirtual + item.arquivoComprovanteTara} target="_blank">Arquivo Comprovante Tara</a></div>}
                                                    {item.arquivoComodato != null && <div className="col-3 col-lg-3"><a href={setupSistema?.caminhoVirtual + item.arquivoComodato} target="_blank">Arquivo Comodato</a></div>}
                                                </div>
                                                <hr />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            }
                            {requerimento.requerimentoTransportadorLocalGuarda != null && requerimento.requerimentoTransportadorLocalGuarda.length > 0 &&
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <h3 className="titulo-consulta">Locais de Guarda de Veículo</h3>
                                        <div className="line-protocolo"></div>
                                    </div>
                                    <div className="col-12 col-lg-12">
                                        {requerimento.requerimentoTransportadorLocalGuarda.map((item, key) => (
                                            <div key={key}>
                                                <div className="row">
                                                    <div className="col-2 col-lg-2">
                                                        <b>CEP:</b> <p>{item.cep}</p>
                                                    </div>
                                                    <div className="col-4 col-lg-4">
                                                        <b>Endereço:</b> <p>{item.logradouro + ", " + item.numEndereco}</p>
                                                    </div>
                                                    <div className="col-4 col-lg-4">
                                                        <b>Bairro:</b> <p>{item.bairro}</p>
                                                    </div>
                                                    <div className="col-2 col-lg-2">
                                                        <b>Status:</b> <p>{item.status}</p>
                                                    </div>
                                                </div>
                                                <hr />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            }
                            {requerimento.requerimentoTransportadorLocalDestino != null && requerimento.requerimentoTransportadorLocalDestino.length > 0 &&
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <h3 className="titulo-consulta">Locais de Destinação</h3>
                                        <div className="line-protocolo"></div>
                                    </div>
                                    <div className="col-12 col-lg-12">
                                        {requerimento.requerimentoTransportadorLocalDestino.map((item, key) => (
                                            <div key={key}>
                                                <div className="row">
                                                    <div className="col-2 col-lg-2">
                                                        <b>CNPJ:</b> <p>{item.cnpj}</p>
                                                    </div>
                                                    <div className="col-4 col-lg-4">
                                                        <b>Fantasia:</b> <p>{item.fantasia}</p>
                                                    </div>
                                                    <div className="col-4 col-lg-4">
                                                        <b>Razão Social:</b> <p>{item.razaoSocial}</p>
                                                    </div>
                                                    <div className="col-2 col-lg-2">
                                                        <b>Status:</b> <p>{item.status}</p>
                                                    </div>
                                                    <div className="col-2 col-lg-2">
                                                        <b>CEP:</b> <p>{item.cep}</p>
                                                    </div>
                                                    <div className="col-4 col-lg-4">
                                                        <b>Endereço:</b> <p>{item.logradouro + ", " + item.numEndereco}</p>
                                                    </div>
                                                    <div className="col-3 col-lg-3">
                                                        <b>Bairro:</b> <p>{item.bairro}</p>
                                                    </div>
                                                    <div className="col-3 col-lg-3">
                                                        <b>Cidade:</b> <p>{item.cidade}</p>
                                                    </div>
                                                </div>
                                                <hr />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            }
                            {requerimento.requerimentoTransportadorEquipamento != null && requerimento.requerimentoTransportadorEquipamento.length > 0 &&
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <h3 className="titulo-consulta">{requerimento.setupSolicitacaoAcao.acao == "Exclusão de Equipamentos" ? "Equipamentos Selecionados para Exclusão" : "Equipamentos"}</h3>
                                        <div className="line-protocolo"></div>
                                    </div>
                                    <div className="col-12 col-lg-12">
                                        {requerimento.requerimentoTransportadorEquipamento.map((item, key) => (
                                            <div key={key}>
                                                <div className="row">
                                                    <div className="col-2 col-lg-2">
                                                        <b>Número:</b> <p>{item.numeroEquipamento}</p>
                                                    </div>
                                                    <div className="col-2 col-lg-2">
                                                        <b>Tipo:</b> <p>{item.tipo}</p>
                                                    </div>
                                                    <div className="col-3 col-lg-3">
                                                        <b>Dimensão:</b> <p>{item.dimensao}</p>
                                                    </div>
                                                    <div className="col-3 col-lg-3">
                                                        <b>Capacidade (m³):</b> <p>{item.capacidadeVolume}</p>
                                                    </div>
                                                    <div className="col-2 col-lg-2">
                                                        <b>Status:</b> <p>{item.status}</p>
                                                    </div>
                                                </div>
                                                <hr />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            }
                            <div className="row">
                                <div className="col-12 col-lg-12">
                                    <h3 className="titulo-consulta">Documentos</h3>
                                    <div className="line-protocolo"></div>
                                </div>

                                <MaterialTable style={{ minHeight: "auto", width: "100%" }}
                                    title=""
                                    columns={[
                                        { title: 'Documento', field: 'documento.descricao' },
                                        { title: 'Arquivo', field: 'arquivo' },
                                        { title: 'Status Análise', field: 'statusAnalise' },
                                        { title: 'Motivo Reprova', field: 'motivoReprovaAnalise' }
                                    ]}
                                    data={requerimento.requerimentoDocumento}
                                    isLoading={false}
                                    actions={[
                                        {
                                            icon: 'insert_drive_file',
                                            tooltip: 'Visualizar Documento',
                                            onClick: (event, rowData) => window.open(setupSistema?.caminhoVirtual + rowData.arquivo, '_blank')
                                        }
                                    ]}
                                    localization={table_translate}
                                    options={table_style}
                                />
                            </div>

                            {!!requerimento?.requerimentoTaxaFislurb &&
                                requerimento?.requerimentoTaxaFislurb.length > 0 && <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <h3 className="titulo-consulta">Identificação Taxa FisLurb</h3>
                                        <div className="line-protocolo"></div>
                                    </div>

                                    <div className="col-12 col-lg-12">
                                        <div className="row">
                                            <div className="col-2 col-lg-2">
                                                <b>Tipo de Empresa</b> <p>{requerimento?.requerimentoTaxaFislurb[0]?.tipoEmpresa}</p>
                                            </div>
                                            <div className="col-2 col-lg-2">
                                                <b>Faixa de Valores:</b> <p>{requerimento?.requerimentoTaxaFislurb[0]?.faixaValores}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-lg-12">
                                        <h3 className="titulo-consulta">Anexos Taxa FisLurb</h3>
                                        <div className="line-protocolo"></div>
                                    </div>

                                    <MaterialTable
                                        style={{ minHeight: "auto", width: "100%" }}
                                        title=""
                                        columns={[
                                            { title: "Arquivo", field: "guiaArrecadacao" },
                                            {
                                                title: "Data Pagamento",
                                                field: "dataPagamento",
                                                render: rowData =>
                                                    rowData.dataPagamento
                                                        ? moment(rowData.dataPagamento).format("DD/MM/YYYY")
                                                        : "",
                                            },
                                            {
                                                title: "Usuário Confirmação Pagamento",
                                                field: "usuarioConfirmacaoPagamento",
                                                render: rowData =>
                                                    rowData?.usuario
                                                        ? rowData?.usuario?.nome
                                                        : "",
                                            },
                                        ]}
                                        data={requerimento?.requerimentoTaxaFislurb[0].requerimentoTaxaFislurbBoletos}
                                        isLoading={false}
                                        actions={[
                                            {
                                                icon: "insert_drive_file",
                                                tooltip: "Visualizar Documento",
                                                onClick: (event, rowData) =>
                                                    window.open(
                                                        setupSistema?.caminhoVirtual + rowData.guiaArrecadacao,
                                                        "_blank"
                                                    ),
                                            },
                                        ]}
                                        localization={table_translate}
                                        options={table_style}
                                    />
                                </div>}

                            {session != null && requerimento && !!requerimento?.observacaoRequerente &&
                                <div className="row mt-4">
                                    <div className="col-12 col-lg-12">
                                        <h3 className="titulo-consulta">Observações do Requerente</h3>
                                        <div className="line-protocolo"></div>
                                    </div>

                                    <div className="col-12 col-lg-12 mt-2">
                                        <p>{requerimento?.observacaoRequerente}</p>
                                    </div>
                                </div>
                            }

                            {setupSistema && setupSistema.metodologiaCobranca == "Integração PRODAM" && requerimento.requerimentoCobrancas.length > 0 &&
                                <div className="row mt-4">
                                    <div className="col-12 col-lg-12">
                                        <h3 className="titulo-consulta">Cobranças</h3>
                                        <div className="line-protocolo"></div>
                                    </div>

                                    <MaterialTable style={{ minHeight: "auto", width: "100%" }}
                                        title=""
                                        columns={[
                                            { title: 'Status', field: 'status' },
                                            { title: 'Vencimento', field: 'dataVencimento', render: (rowData) => formateDateandTime(rowData.dataVencimento) },
                                            {
                                                title: 'Último Retorno', field: 'status',
                                                render: (rowData) => rowData.logCobrancas && rowData.logCobrancas.length > 0 ? formateDateandTime(rowData.logCobrancas[rowData.logCobrancas.length - 1].dataHora) : ""
                                            },
                                            {
                                                title: 'Retorno', field: 'status',
                                                render: (rowData) => rowData.logCobrancas && rowData.logCobrancas.length > 0 ? rowData.logCobrancas[rowData.logCobrancas.length - 1].retorno : ""
                                            },
                                        ]}
                                        data={requerimento.requerimentoCobrancas}
                                        isLoading={false}
                                        actions={[
                                            {
                                                icon: 'insert_drive_file',
                                                tooltip: 'Visualizar',
                                                onClick: (event, rowData) => openGuiaCobranca(rowData)
                                            }
                                        ]}
                                        localization={table_translate}
                                        options={table_style}
                                    />
                                </div>
                            }
                            {historicoAnaliseGestor.length > 0 &&
                                <div className="row mt-4">
                                    <div className="col-12 col-lg-12">
                                        <h3 className="titulo-consulta">Histórico de Análise Gestor</h3>
                                        <div className="line-protocolo"></div>
                                    </div>

                                    <MaterialTable style={{ minHeight: "auto", width: "100%" }}
                                        title=""
                                        columns={[
                                            { title: 'Tipo de Análise', field: 'tipoAnalise' },
                                            { title: 'Data Análise', field: 'dataAnalise', render: (rowData) => formateDateandTime(rowData.dataAnalise) },
                                            { title: 'Usuário', field: 'usuarioAnalise_Nome' },
                                            { title: 'Aprovado', field: 'aceite', render: (rowData) => rowData.aceite ? "Sim" : "Não" },
                                            { title: 'Observação', field: 'observacao' },
                                            { title: 'Data de Aceite', field: 'dataAceite', render: (rowData) => rowData.dataAceite ? formateDateandTime(rowData.dataAceite) : "" },
                                        ]}
                                        data={historicoAnaliseGestor}
                                        isLoading={false}
                                        localization={table_translate}
                                        options={table_style}
                                    />
                                </div>
                            }
                            {setupSistema && setupSistema.metodologiaCobranca == "Email" && requerimento.requerimentoCobrancas.length > 0 &&
                                requerimento.requerimentoCobrancas[0].requerimentoCobrancaComprovantes.length > 0 &&
                                <div className="row mt-4 noPrint">
                                    <div className="col-12 col-lg-12 mb-2">
                                        <h3 className="titulo-consulta">Comprovante de Pagamento</h3>
                                        <div className="line-protocolo"></div>
                                    </div>
                                    {requerimento.requerimentoCobrancas[0].requerimentoCobrancaComprovantes.map((m, key) => {
                                        return <div className="col-12 col-lg-12" key={key}>
                                            <a href={setupSistema.caminhoVirtual + m.arquivo} target="_blank"><i className="fas fa-file"></i> Comprovante enviado em {formateDate(m.dataImportacao)}</a>
                                        </div>
                                    })}
                                </div>
                            }

                            {session != null && requerimento && requerimento?.status == "Cancelado" &&
                                <div className="row mt-4">
                                    <div className="col-12 col-lg-12">
                                        <h3 className="titulo-consulta">Cancelamento</h3>
                                        <div className="line-protocolo"></div>
                                    </div>
                                    <div className="col-12 col-lg-12">
                                        <div className="row">
                                            <div className="col-12 col-lg-8">
                                                <b>Justificativa:</b>
                                                <p>{requerimento.justificativaCancelamento}</p>
                                            </div>
                                            <div className="col-12 col-lg-2">
                                                <b>Responsável:</b>
                                                <p>{requerimento.usuarioCancelamento_Nome}</p>
                                            </div>
                                            <div className="col-12 col-lg-2">
                                                <b>Data/Hora:</b>
                                                <p>{formateDateandTime(requerimento.dataCancelamento)}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            {showAcoesGestor && session != null && session.tipoAcesso == "AreaRestrita" && requerimento != null && requerimento.status != "Finalizado" &&
                                <div className="mt-4 noPrint">
                                    <AcoesGestor
                                        requerimento={requerimento}
                                        handleReturn={handleReturn}></AcoesGestor>
                                </div>
                            }

                            {(session == null || (session && session.tipoAcesso == "Protocolo")) &&
                                requerimento.status == "Pendente" &&
                                requerimento.fluxoCadastroEtapaAtual != null &&
                                requerimento.fluxoCadastroEtapaAtual.tipo == "Emissão de Guia" &&
                                setupSistema && setupSistema.metodologiaCobranca == "Integração PRODAM" &&
                                <div
                                    className="text-center"
                                >
                                    <Button
                                        color="secondary"
                                        onClick={() => {
                                            if (requerimento?.requerimentoCobrancas.filter(x => x.status == "Pendente").length > 0) {
                                                showMessage("Aviso", "Não é permitido emitir um novo boleto, pois você tem boletos pendentes.", "warning", null);
                                                return;
                                            } else {
                                                handleEmitirGuia();
                                            }
                                        }}
                                        className="btn-mobile"
                                        type="button"
                                    >
                                        Emitir Guia
                                    </Button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </>
    )
}
